/* theme-sync-rev: 2026-10-01-pdp-reviews-v3 — bump on every change to this file.
   The dev→Shopify sync is per-file content-hash based and can leave ONE file
   stale while its siblings update (kkumi-debugging-playbook §3.5, the "pink
   loader" incident). Editing this line guarantees the hash moves. The live
   build is readable without the debug panel: the section root carries
   data-kkprv-build. */
/* PDP reviews (sections/kkumi-product-reviews-photowall.liquid), rebuilt to
   the Kkumi_Mockups_20 handoff:
     - summary card: average, hearts (rounded to .5), "Based on N reviews",
       and the 5→1 breakdown bars, each a toggle filter for that rating;
     - a plain written-review list (never clamped) with "Load more";
     - rating-only reviews (no title/body/photo) as a compact tile grid
       under the list, so they never render as empty cards;
     - "All" / "With written review" / "{k}♥ ✕" chips and a sort select;
     - "Helpful (n)" votes, one per visitor, counted by the rewards worker
       (/apps/rewards/reviews/helpful — apps/rewards/src/handlers/review-helpful.js).
   The write-a-review modal lives in section-kkumi-product-reviews-photowall-modal.js. */
  (function () {
    var root = document.querySelector('[data-kkprv]');
    if (!root) { console.warn('[kkprv] root not found'); return; }
    var SID = root.dataset.sectionId || '';

    /* =========================================================
     * DBG — silent unless the "Debug panel (visible)" setting is
     * on, then writes to both the console and the on-page panel.
     * ========================================================= */
    var debugOn = root.dataset.debug === '1';
    var debugPanelEl = root.querySelector('[data-kkprv-debug]');
    var debugLogEl = root.querySelector('[data-kkprv-debug-log]');
    function dbg(label, data) {
      if (!debugOn) return;
      var msg = '[kkprv ' + SID + '] ' + label;
      if (typeof data === 'undefined') {
        console.log(msg);
      } else {
        console.log(msg, data);
      }
      if (debugLogEl) {
        var ts = new Date().toISOString().split('T')[1].split('.')[0];
        var line = '[' + ts + '] ' + label;
        if (typeof data !== 'undefined') {
          try { line += ': ' + JSON.stringify(data, null, 2); } catch (e) { line += ': ' + String(data); }
        }
        debugLogEl.textContent += line + '\n\n';
        debugLogEl.scrollTop = debugLogEl.scrollHeight;
      }
    }

    var ASSET_REV = '2026-10-01-pdp-reviews-v3';
    var sectionRev = root.dataset.kkprvBuild || '(none)';
    dbg('init', { mode: root.dataset.mode, asset_rev: ASSET_REV, section_rev: sectionRev });
    if (sectionRev !== '(none)' && sectionRev !== ASSET_REV) {
      // The two halves of this section synced at different times — the classic
      // partial theme sync. Say so loudly; it is the difference between "the
      // feature is broken" and "the feature has not landed yet".
      console.warn('[kkprv] STALE THEME SYNC: section is ' + sectionRev + ' but ' +
        'section-kkumi-product-reviews-photowall.js is ' + ASSET_REV +
        ' — one of the two has not re-synced yet.');
    }
    try {
      var initInfo = JSON.parse(root.dataset.debugInit || '{}');
      dbg('section settings (server-rendered)', initInfo);
    } catch (e) { console.warn('[kkprv ' + SID + '] could not parse debug-init', e); }

    if (debugPanelEl) {
      var toggle = debugPanelEl.querySelector('[data-kkprv-debug-toggle]');
      var copyBtn = debugPanelEl.querySelector('[data-kkprv-debug-copy]');
      var clearBtn = debugPanelEl.querySelector('[data-kkprv-debug-clear]');
      if (toggle) {
        toggle.addEventListener('click', function () {
          debugPanelEl.classList.toggle('is-collapsed');
          toggle.textContent = debugPanelEl.classList.contains('is-collapsed') ? '+' : '−';
        });
      }
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var text = debugLogEl ? debugLogEl.textContent : '';
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).then(
              function () { copyBtn.textContent = 'Copied'; setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1500); },
              function () { copyBtn.textContent = 'Failed'; }
            );
          } else if (debugLogEl) {
            // Fallback: select the log so the user can ctrl+c
            var range = document.createRange();
            range.selectNodeContents(debugLogEl);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
          }
        });
      }
      if (clearBtn) {
        clearBtn.addEventListener('click', function () { if (debugLogEl) debugLogEl.textContent = ''; });
      }
    }

    /* =========================================================
     * Shared helpers
     * ========================================================= */
    var esc = window.KKEsc || function (s) {
      return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    };
    // Editable copy (section settings → data-* on the root), with the design
    // literal as the fallback. {n} tokens are substituted with the live number.
    function copy(key, fallback) {
      var v = root.dataset[key];
      return (v == null || v === '') ? fallback : v;
    }
    function withN(tpl, n) { return String(tpl).split('{n}').join(String(n)); }

    var HEART_PATH = 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z';
    function heartSvg(cls) {
      return '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"' + (cls ? ' class="' + cls + '"' : '') + '><path d="' + HEART_PATH + '"/></svg>';
    }
    // Flat filled / empty hearts; a half heart is an empty heart with a filled
    // one clipped to 50% laid over it. Ratings round to the nearest .5; the
    // summary's average rounds DOWN to .5 (a 4.7 never shows as five hearts).
    function heartsHtml(value, extraClass, floor) {
      var v = (floor ? Math.floor : Math.round)((Number(value) || 0) * 2) / 2;
      var out = '';
      for (var i = 1; i <= 5; i++) {
        if (v >= i) out += heartSvg();
        else if (v > i - 1) out += '<span class="kkprv-half">' + heartSvg('is-off') + '<span>' + heartSvg() + '</span></span>';
        else out += heartSvg('is-off');
      }
      var label = withN(copy('ariaStars', '{n} of 5'), v);
      return '<span class="kkprv-hearts' + (extraClass ? ' ' + extraClass : '') + '" role="img" aria-label="' + esc(label) + '">' + out + '</span>';
    }
    var PLAY = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6 4l14 8-14 8z"/></svg>';
    function fmtN(n) { return Number(n || 0).toLocaleString('en-AU'); }
    var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';
    var THUMB = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 10v12"/><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z"/></svg>';

    function formatRelative(dateStr) {
      if (!dateStr) return '';
      var d = new Date(dateStr);
      if (isNaN(d)) return '';
      var days = Math.floor((Date.now() - d.getTime()) / 86400000);
      if (days <= 0) return copy('dateToday', 'Today');
      if (days === 1) return copy('dateYesterday', 'Yesterday');
      if (days < 7)   return withN(copy('dateDays', '{n} days ago'), days);
      if (days < 30)  { var w = Math.floor(days / 7);  return withN(copy(w === 1 ? 'dateWeekOne'  : 'dateWeekOther',  '{n} week'  + (w === 1 ? '' : 's') + ' ago'), w); }
      if (days < 365) { var m = Math.floor(days / 30); return withN(copy(m === 1 ? 'dateMonthOne' : 'dateMonthOther', '{n} month' + (m === 1 ? '' : 's') + ' ago'), m); }
      var y = Math.floor(days / 365); return withN(copy(y === 1 ? 'dateYearOne' : 'dateYearOther', '{n} year' + (y === 1 ? '' : 's') + ' ago'), y);
    }
    // Review photo URLs: https only (Shopify CDN URLs arrive protocol-relative).
    function safeUrl(u) {
      if (typeof u !== 'string' || !u) return '';
      if (/^\/\//.test(u)) u = 'https:' + u;
      return /^https:\/\//i.test(u) ? u : '';
    }
    var VIDEO_RE = /\.(mp4|mov|webm|m4v)(\?|#|$)/i;
    function fmtDuration(sec) {
      sec = Math.round(Number(sec) || 0);
      if (sec <= 0) return '';
      return Math.floor(sec / 60) + ':' + ('0' + (sec % 60)).slice(-2);
    }
    // One media shape for photos and videos:
    //   { type: 'image'|'video', thumb, full, src, duration }
    // Judge.me's picture objects carry urls{original,huge,…}; its video payload
    // isn't documented, so videos are read defensively from a `videos` array
    // (url / urls / src + a thumbnail) and from any "picture" that is really a
    // video file.
    function picture(p) {
      if (!p) return null;
      if (typeof p === 'string') {
        var u0 = safeUrl(p);
        if (!u0) return null;
        return VIDEO_RE.test(u0) ? { type: 'video', thumb: '', full: '', src: u0, duration: '' } : { type: 'image', thumb: u0, full: u0, src: '', duration: '' };
      }
      var u = p.urls || p;
      var full = safeUrl(u.original || u.huge || u.url || u.src || '');
      if (!full) return null;
      if (VIDEO_RE.test(full) || p.video === true || p.type === 'video') return videoItem(p);
      var thumb = safeUrl(u.small || u.compact || u.medium || u.huge || u.original || u.url || '');
      return { type: 'image', thumb: thumb || full, full: full, src: '', duration: '' };
    }
    function videoItem(v) {
      if (!v) return null;
      if (typeof v === 'string') return picture(v);
      var u = v.urls || {};
      var src = safeUrl(v.url || v.src || v.video_url || u.original || u.mp4 || u.url || '');
      if (!src) return null;
      var poster = safeUrl(v.thumbnail_url || v.thumbnail || v.poster || v.preview_image || u.thumbnail || u.poster || '');
      return { type: 'video', thumb: poster, full: poster, src: src, duration: fmtDuration(v.duration || v.duration_seconds) };
    }

    // Imported reviews often required a body, so the importer filled it with
    // the product title. Showing that back reads as a duplicate of the product
    // the review sits under, so drop it and let the rating stand alone.
    function normalizeText(v) {
      return String(v || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    }
    function meaningfulText(value, productTitle) {
      var text = String(value || '').trim();
      if (!text) return '';
      var product = normalizeText(productTitle);
      if (product && normalizeText(text) === product) return '';
      return text;
    }

    // A review is this product's when Judge.me's handle or either of its id
    // fields matches. Shared by the main product filter and the bundle
    // component fetches so both agree on what "belongs to product X" means.
    function reviewMatchesProduct(r, handle, id) {
      if (!handle && !id) return true;
      var handleMatch = handle && r.product_handle && String(r.product_handle).toLowerCase() === String(handle).toLowerCase();
      var idMatch = id && (String(r.product_external_id) === String(id) || String(r.product_id) === String(id));
      return !!(handleMatch || idMatch);
    }
    function reviewIsVisible(r) {
      return r.published !== false && !r.hidden;
    }

    /* =========================================================
     * One review shape for API and demo data
     *   { id, rating, title, body, name, verified, variant, ts, dateLabel,
     *     helpful, media[], order, pill }
     * ========================================================= */
    function variantLabel(variantMap, vId) {
      var t = vId && variantMap[vId];
      if (!t || t === 'Default Title') return '';
      return String(t).split(' / ').join(' · ');
    }
    function fromApi(r, i, variantMap, productTitle) {
      // Trim first: a rating-only review can come back with a single space as
      // its body (see the empty-body fallback in kkumi-reviews-proxy.js).
      var own = productTitle || r.product_title;
      var date = r.created_at || r.updated_at || '';
      var ts = Date.parse(date);
      var media = (r.pictures || []).map(picture).concat((r.videos || []).map(videoItem)).filter(Boolean);
      return {
        id: r.id != null ? String(r.id) : '',
        rating: Math.max(1, Math.min(5, parseInt(r.rating, 10) || 5)),
        title: meaningfulText(r.title, own),
        body: meaningfulText(r.body, own),
        name: (r.reviewer && r.reviewer.name) || '',
        verified: !!r.verified_buyer,
        variant: variantLabel(variantMap || {}, r.product_variant_id),
        ts: isNaN(ts) ? null : ts,
        dateLabel: formatRelative(date),
        helpful: 0,
        media: media,
        order: i,
        pill: '',
      };
    }
    function fromDemo(d, i) {
      var media = [];
      var img = safeUrl(d.image);
      if (img) media.push({ type: 'image', thumb: img, full: img, src: '', duration: '' });
      if (d.video && safeUrl(d.video.url)) {
        var poster = safeUrl(d.video.poster);
        media.push({ type: 'video', thumb: poster, full: poster, src: safeUrl(d.video.url), duration: fmtDuration(d.video.duration) });
      }
      return {
        id: String(d.id || 'demo-' + i),
        rating: Math.max(1, Math.min(5, parseInt(d.rating, 10) || 5)),
        title: String(d.title || '').trim(),
        body: String(d.body || '').trim(),
        name: String(d.author || '').trim(),
        verified: !!d.verified,
        variant: String(d.pill || '').trim(),
        ts: null,
        dateLabel: String(d.date_label || ''),
        helpful: parseInt(d.helpful, 10) || 0,
        media: media,
        order: i,
        pill: '',
      };
    }
    // A review "has content" — and goes in the list rather than the rating
    // tiles — when it has words or media. (A title alone counts too, so a
    // title-only review is never reduced to a tile.)
    function hasMedia(r) { return r.media.length > 0; }
    function isWritten(r) { return !!(r.body || r.title || hasMedia(r)); }

    /* =========================================================
     * Helpful votes — counted by the rewards worker via the App Proxy.
     * Guests are identified by a random per-browser id (the worker stores
     * only an HMAC of it); logged-in shoppers by the signed customer id.
     * ========================================================= */
    var helpfulUrl = (root.dataset.helpfulUrl || '').trim();
    var helpful = { on: false, counts: {}, voted: {} };
    function visitorId() {
      var key = 'kkprv:vid';
      try {
        var v = localStorage.getItem(key);
        if (v && /^[A-Za-z0-9-]{16,64}$/.test(v)) return v;
      } catch (e) { /* storage blocked — fall through to a per-page id */ }
      var id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
        : (Date.now().toString(16) + Math.random().toString(16).slice(2) + Math.random().toString(16).slice(2)).slice(0, 32);
      try { localStorage.setItem(key, id); } catch (e) {}
      return id;
    }
    var VID = helpfulUrl ? visitorId() : '';
    function isLiveId(id) { return /^\d{1,20}$/.test(id); }

    function loadHelpful(reviews) {
      if (!helpfulUrl) return;
      var demoIds = reviews.filter(function (r) { return !isLiveId(r.id) && isWritten(r); });
      if (demoIds.length && root.dataset.mode !== 'api') {
        // Demo mode: block counts, voting stays local to the page.
        demoIds.forEach(function (r) { helpful.counts[r.id] = r.helpful; });
        helpful.on = true;
        paintHelpful();
      }
      var ids = reviews.filter(function (r) { return isLiveId(r.id) && isWritten(r); }).map(function (r) { return r.id; });
      if (!ids.length) return;
      var url = helpfulUrl + (helpfulUrl.indexOf('?') >= 0 ? '&' : '?') +
        'ids=' + encodeURIComponent(ids.slice(0, 100).join(',')) + '&vid=' + encodeURIComponent(VID);
      fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (d) {
          var c = (d && d.counts) || {};
          Object.keys(c).forEach(function (id) { helpful.counts[id] = Number(c[id]) || 0; });
          ((d && d.voted) || []).forEach(function (id) { helpful.voted[id] = true; });
          helpful.on = true;
          if (state.sort === 'help') renderList();
          dbg('helpful — counts loaded', { ids: ids.length, voted: (d && d.voted) || [] });
          paintHelpful();
        })
        .catch(function (e) {
          // Votes backend unreachable (not deployed yet, proxy down): the
          // button stays hidden rather than offering a vote that can't land.
          dbg('helpful — counts FAILED, button hidden', String(e));
        });
    }

    function paintHelpful() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-kkprv-help]'), function (btn) {
        var id = btn.getAttribute('data-kkprv-help');
        btn.hidden = !helpful.on;
        var on = !!helpful.voted[id];
        btn.classList.toggle('is-on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var n = btn.querySelector('[data-kkprv-help-n]');
        if (n) n.textContent = '(' + (helpful.counts[id] || 0) + ')';
      });
    }

    function vote(btn) {
      var id = btn.getAttribute('data-kkprv-help');
      if (!id || helpful.voted[id] || btn.getAttribute('aria-busy') === 'true') return;
      // Optimistic: the vote shows at once and is rolled back if it fails.
      helpful.voted[id] = true;
      helpful.counts[id] = (helpful.counts[id] || 0) + 1;
      paintHelpful();
      if (!isLiveId(id)) return; // demo review — nothing to send
      btn.setAttribute('aria-busy', 'true');
      fetch(helpfulUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ review_id: id, vid: VID }),
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && res.body.error) || 'vote_failed');
          helpful.counts[id] = Number(res.body.count) || helpful.counts[id];
          dbg('helpful — voted', res.body);
        })
        .catch(function (e) {
          helpful.voted[id] = false;
          helpful.counts[id] = Math.max(0, (helpful.counts[id] || 1) - 1);
          dbg('helpful — vote FAILED, rolled back', String(e));
        })
        .then(function () {
          btn.removeAttribute('aria-busy');
          paintHelpful();
        });
    }

    /* =========================================================
     * Rendering
     * ========================================================= */
    var perPage = parseInt(root.dataset.perPage || '5', 10) || 5;
    var loadMoreOn = root.dataset.loadMore !== '0';
    var GAL_CAP = Math.max(2, parseInt(root.dataset.galleryCap || '9', 10) || 9);
    var QUIET_CAP = Math.max(1, parseInt(root.dataset.quietCap || '11', 10) || 11);
    function moreLabel(n) { return withN(copy('moreTpl', 'Show {n} more reviews'), fmtN(n)); }

    // ---- media thumbnail (inline, gallery and lightbox strip) -----------------
    // `ref` is "<list>:<index>" into the lightbox list it opens.
    function thumbHtml(r, m, ref, opts) {
      opts = opts || {};
      var aria = opts.aria || copy(m.type === 'video' ? 'videoAria' : 'photoAria',
        m.type === 'video' ? 'Play video from {name}' : 'View photo from {name}').split('{name}').join(r.name || '');
      var html = '<button type="button" class="kkprv-thumb' + (opts.cls ? ' ' + opts.cls : '') + '" data-kkprv-media="' + esc(ref) + '" aria-label="' + esc(aria) + '">';
      if (m.thumb) html += '<img class="kk-img-skel" src="' + esc(m.thumb) + '" alt="" loading="lazy" decoding="async">';
      if (m.type === 'video' && !opts.over) {
        html += '<span class="kkprv-thumb__play" aria-hidden="true"><span>' + PLAY + '</span></span>';
        if (m.duration) html += '<span class="kkprv-thumb__dur" aria-hidden="true">' + esc(m.duration) + '</span>';
      }
      if (opts.over) html += opts.over;
      return html + '</button>';
    }

    // Lightbox lists: 'main' = every media item across this product's reviews
    // (newest first), 'bundle' = the component block's. Each entry { r, mi }.
    var MEDIA = { main: [], bundle: [] };
    function mediaIndex(list, r, mi) {
      var L = MEDIA[list];
      for (var i = 0; i < L.length; i++) if (L[i].r === r && L[i].mi === mi) return i;
      return -1;
    }

    function reviewRowHtml(r, opts) {
      opts = opts || {};
      var list = opts.component ? 'bundle' : 'main';
      var html = '<article class="kkprv-rev' + (opts.component ? ' kkprv-rev--component' : '') + '"' +
        (opts.ariaLabel ? ' aria-label="' + esc(opts.ariaLabel) + '"' : '') + '>';
      html += '<div class="kkprv-rev__top">' + heartsHtml(r.rating) +
        (r.dateLabel ? '<span class="kkprv-rev__date">' + esc(r.dateLabel) + '</span>' : '') + '</div>';
      if (r.pill) html += '<span class="kkprv-rev__pill">' + esc(r.pill) + '</span>';
      if (r.title) html += '<h3 class="kkprv-rev__title">' + esc(r.title) + '</h3>';
      if (r.body) html += bodyHtml(r.body);
      if (hasMedia(r)) {
        html += '<div class="kkprv-rev__media">' + r.media.map(function (m, mi) {
          return thumbHtml(r, m, list + ':' + mediaIndex(list, r, mi));
        }).join('') + '</div>';
      }
      html += '<div class="kkprv-rev__foot">' + whoHtml(r);
      if (!opts.component && helpfulUrl && r.id) {
        html += '<button type="button" class="kkprv-help" data-kkprv-help="' + esc(r.id) + '" aria-pressed="false"' +
          (helpful.on ? '' : ' hidden') + '>' + THUMB + esc(copy('helpfulLabel', 'Helpful')) +
          ' <span data-kkprv-help-n>(' + fmtN(helpful.counts[r.id] || 0) + ')</span></button>';
      }
      html += '</div></article>';
      return html;
    }
    function bodyHtml(body) {
      return '<div class="kkprv-rev__body">' + body.split(/\n+/).map(function (p) { return '<p>' + esc(p) + '</p>'; }).join('') + '</div>';
    }
    function whoHtml(r) {
      var html = '<div class="kkprv-rev__who">';
      if (r.name) html += '<b>' + esc(r.name) + '</b>';
      if (r.verified) html += '<span class="kkprv-rev__ok">' + TICK + esc(copy('verifiedLabel', 'Verified buyer')) + '</span>';
      if (r.variant) html += '<span class="kkprv-rev__var">' + esc(r.variant) + '</span>';
      return html + '</div>';
    }

    function quietTileHtml(r) {
      return '<div class="kkprv-qr"><span class="kkprv-qr__n">' + esc(r.name || copy('reviewNounOne', 'review')) + '</span>' +
        '<div class="kkprv-qr__row">' + heartsHtml(r.rating) +
        (r.dateLabel ? '<span class="kkprv-qr__d">' + esc(r.dateLabel) + '</span>' : '') + '</div></div>';
    }

    var REVIEWS = [];
    var state = { star: 0, f: 'all', sort: 'new', shown: perPage };

    function byNew(a, b) {
      if (a.ts != null && b.ts != null && a.ts !== b.ts) return b.ts - a.ts;
      return a.order - b.order;
    }
    function helpfulOf(r) { return helpful.counts[r.id] != null ? helpful.counts[r.id] : r.helpful; }
    function sorted(list) {
      var out = list.slice();
      var cmp = {
        media: function (a, b) { return (hasMedia(b) ? 1 : 0) - (hasMedia(a) ? 1 : 0) || byNew(a, b); },
        help: function (a, b) { return helpfulOf(b) - helpfulOf(a) || byNew(a, b); },
        high: function (a, b) { return b.rating - a.rating || byNew(a, b); },
        low: function (a, b) { return a.rating - b.rating || byNew(a, b); },
      }[state.sort] || byNew;
      return out.sort(cmp);
    }

    function renderSummary() {
      var total = REVIEWS.length;
      var sum = 0;
      var counts = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      REVIEWS.forEach(function (r) { sum += r.rating; counts[r.rating]++; });
      var avg = total ? sum / total : 0;
      var avgEl = root.querySelector('[data-kkprv-avg]');
      if (avgEl) avgEl.textContent = avg.toFixed(1);
      var heartsEl = root.querySelector('[data-kkprv-avg-hearts]');
      if (heartsEl) heartsEl.outerHTML = heartsHtml(avg, 'kkprv-hearts--lg', true);
      var noun = total === 1 ? copy('reviewNounOne', 'review') : copy('reviewNounOther', 'reviews');
      var countEl = root.querySelector('[data-kkprv-count]');
      if (countEl) countEl.textContent = withN(copy('summaryCountTpl', 'Based on {n} {noun}'), fmtN(total)).split('{noun}').join(noun).replace(/<[^>]*>/g, '');
      var bars = root.querySelector('[data-kkprv-bars]');
      if (bars) {
        bars.innerHTML = [5, 4, 3, 2, 1].map(function (k) {
          var c = counts[k];
          var pct = total ? (c / total) * 100 : 0;
          var on = state.star === k;
          var aria = copy('barAriaTpl', 'Show {k}-heart reviews ({n})').split('{k}').join(String(k)).split('{n}').join(fmtN(c));
          return '<button type="button" class="kkprv-bar' + (on ? ' is-on' : '') + '" data-k="' + k + '"' + (c ? '' : ' disabled') +
            ' aria-pressed="' + on + '" aria-label="' + esc(aria) + '">' +
            '<span class="kkprv-bar__k">' + k + heartSvg() + '</span>' +
            '<span class="kkprv-bar__t"><span class="kkprv-bar__f" style="width:' + pct.toFixed(1) + '%"></span></span>' +
            '<span class="kkprv-bar__n">' + fmtN(c) + '</span></button>';
        }).join('');
      }
    }

    // Gallery: every photo/video across the product's reviews, newest first.
    // Capped; the last tile becomes "+N see all" and opens the lightbox there.
    function renderGallery() {
      MEDIA.main = [];
      REVIEWS.slice().sort(byNew).forEach(function (r) {
        r.media.forEach(function (m, mi) { MEDIA.main.push({ r: r, mi: mi }); });
      });
      var gal = root.querySelector('[data-kkprv-gal]');
      var row = root.querySelector('[data-kkprv-gal-row]');
      if (!gal || !row) return;
      var all = MEDIA.main;
      gal.hidden = !all.length;
      if (!all.length) { row.innerHTML = ''; return; }
      var shown = all.slice(0, GAL_CAP);
      var rest = all.length - shown.length;
      row.innerHTML = shown.map(function (x, k) {
        var m = x.r.media[x.mi];
        if (k === GAL_CAP - 1 && rest > 0) {
          return thumbHtml(x.r, m, 'main:' + k, {
            aria: withN(copy('seeAllAria', 'See all {n} photos and videos'), fmtN(all.length)),
            over: '<span class="kkprv-thumb__more" aria-hidden="true"><b>+' + fmtN(rest + 1) + '</b>' + esc(copy('seeAll', 'see all')) + '</span>',
          });
        }
        return thumbHtml(x.r, m, 'main:' + k);
      }).join('');
    }

    function renderList() {
      var cText = REVIEWS.filter(function (r) { return !!(r.body || r.title); }).length;
      var cMedia = REVIEWS.filter(hasMedia).length;
      if (state.f === 'media' && !cMedia) state.f = 'all';
      if (state.f === 'text' && !cText) state.f = 'all';
      Array.prototype.forEach.call(root.querySelectorAll('.kkprv-bar[data-k]'), function (b) {
        var on = +b.getAttribute('data-k') === state.star;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var chips = root.querySelector('[data-kkprv-chips]');
      if (chips) {
        var chip = function (id, label, n) {
          var on = state.f === id && (id !== 'all' || !state.star);
          return '<button type="button" class="kkprv-chip' + (on ? ' is-on' : '') + '" data-c="' + id + '" aria-pressed="' + on + '">' +
            esc(label) + ' <span class="kkprv-chip__n">' + fmtN(n) + '</span></button>';
        };
        var html = chip('all', copy('chipAll', 'All'), REVIEWS.length);
        if (cMedia) html += chip('media', copy('chipMedia', 'Photos & videos'), cMedia);
        if (cText) html += chip('text', copy('chipWritten', 'Written'), cText);
        if (state.star) {
          html += '<button type="button" class="kkprv-chip is-on" data-c="clear" aria-label="' + esc(copy('chipClearAria', 'Clear rating filter')) + '">' +
            state.star + heartSvg() + ' <span aria-hidden="true">✕</span></button>';
        }
        chips.innerHTML = html;
      }

      var L = REVIEWS.filter(function (r) { return !state.star || r.rating === state.star; });
      if (state.f === 'media') L = L.filter(hasMedia);
      if (state.f === 'text') L = L.filter(function (r) { return !!(r.body || r.title); });
      L = sorted(L);
      var Wall = L.filter(isWritten);
      var limit = loadMoreOn ? state.shown : Wall.length;
      var W = Wall.slice(0, limit);
      var done = W.length >= Wall.length;
      var Q = L.filter(function (r) { return !isWritten(r); });

      var list = root.querySelector('[data-kkprv-written]');
      if (list) {
        if (!Wall.length && !Q.length) {
          list.innerHTML = '<p class="kkprv__nomatch">' + esc(copy('noMatch', 'No reviews match.')) + ' <button type="button" data-c="all">' +
            esc(copy('showAll', 'Show all')) + '</button></p>';
        } else {
          list.innerHTML = W.map(function (r) { return reviewRowHtml(r); }).join('');
        }
      }
      var moreWrap = root.querySelector('[data-kkprv-more-wrap]');
      if (moreWrap) {
        moreWrap.hidden = done;
        var btn = moreWrap.querySelector('[data-kkprv-more]');
        if (btn) btn.textContent = moreLabel(Math.min(perPage, Wall.length - W.length));
        var showing = moreWrap.querySelector('[data-kkprv-showing]');
        if (showing) showing.textContent = copy('showingTpl', 'Showing {x} of {y}').split('{x}').join(fmtN(W.length)).split('{y}').join(fmtN(Wall.length));
      }

      // Rating-only tiles wait until every written review is on screen.
      var quiet = root.querySelector('[data-kkprv-quiet]');
      if (quiet) {
        if (!done || !Q.length) {
          quiet.innerHTML = '';
        } else {
          var heading = Wall.length
            ? withN(copy(Q.length === 1 ? 'quietOne' : 'quietOther', Q.length === 1 ? '{n} more rating' : '{n} more ratings'), fmtN(Q.length))
            : copy('quietOnly', 'Ratings');
          var tiles = Q.length > QUIET_CAP + 1 ? Q.slice(0, QUIET_CAP) : Q;
          var extra = Q.length - tiles.length;
          quiet.innerHTML = '<h3 class="kkprv__sec-h">' + esc(heading) + '</h3><div class="kkprv__quiet-grid">' +
            tiles.map(quietTileHtml).join('') +
            (extra > 0 ? '<div class="kkprv-qr kkprv-qr--more">' + esc(withN(copy('quietMore', '+{n} more'), fmtN(extra))) + '</div>' : '') +
            '</div>';
        }
      }
      paintHelpful();
      dbg('list', { star: state.star, filter: state.f, sort: state.sort, written: Wall.length, shown: W.length, ratings_only: Q.length });
    }

    function resetPage() { state.shown = perPage; }

    function wireList() {
      root.addEventListener('click', function (e) {
        var bar = e.target.closest('.kkprv-bar[data-k]');
        if (bar && !bar.disabled) {
          var k = +bar.getAttribute('data-k');
          state.star = state.star === k ? 0 : k;
          resetPage();
          renderList();
          return;
        }
        var chip = e.target.closest('[data-c]');
        if (chip && root.contains(chip)) {
          var c = chip.getAttribute('data-c');
          if (c === 'all') { state.star = 0; state.f = 'all'; }
          else if (c === 'clear') state.star = 0;
          else state.f = state.f === c ? 'all' : c;
          resetPage();
          renderList();
          var again = root.querySelector('[data-kkprv-chips] [data-c="' + c + '"]') || root.querySelector('[data-kkprv-chips] [data-c="all"]');
          if (again) again.focus();
          return;
        }
        if (e.target.closest('[data-kkprv-more]')) {
          state.shown += perPage;
          renderList();
          return;
        }
        var th = e.target.closest('[data-kkprv-media]');
        if (th) {
          var ref = th.getAttribute('data-kkprv-media').split(':');
          lightbox.open(ref[0], parseInt(ref[1], 10) || 0, th);
          return;
        }
        var help = e.target.closest('[data-kkprv-help]');
        if (help) vote(help);
      });
      var sortEl = root.querySelector('[data-kkprv-sort]');
      if (sortEl) {
        sortEl.addEventListener('change', function () {
          state.sort = sortEl.value;
          resetPage();
          renderList();
        });
      }
    }

    /* =========================================================
     * Lightbox — steps through every photo/video in a list (the whole
     * product's, or the bundle block's). Bottom sheet under 640px. Arrow
     * keys + Esc; Tab is trapped; focus returns to the opening thumbnail.
     * ========================================================= */
    var lightbox = (function () {
      var lb = root.querySelector('[data-kkprv-lb]');
      if (!lb) return { open: function () {} };
      // Out of the section so no ancestor (overflow, transform) can clip it.
      document.body.appendChild(lb);
      // …carrying the section's colour overrides (inline custom properties).
      if (root.getAttribute('style')) lb.setAttribute('style', root.getAttribute('style'));
      var stage = lb.querySelector('[data-kkprv-lb-stage]');
      var pos = lb.querySelector('[data-kkprv-lb-pos]');
      var prev = lb.querySelector('[data-kkprv-lb-nav="-1"]');
      var next = lb.querySelector('[data-kkprv-lb-nav="1"]');
      var hearts = lb.querySelector('[data-kkprv-lb-hearts]');
      var strip = lb.querySelector('[data-kkprv-lb-strip]');
      var t = lb.querySelector('[data-kkprv-lb-t]');
      var b = lb.querySelector('[data-kkprv-lb-b]');
      var who = lb.querySelector('[data-kkprv-lb-who]');
      var closeBtn = lb.querySelector('[data-kkprv-lb-close]');
      var listName = 'main';
      var cur = 0;
      var opener = null;
      var prevOverflow = '';

      function clearStage() {
        Array.prototype.forEach.call(stage.querySelectorAll('img, video'), function (n) { n.remove(); });
      }
      function show(k) {
        var L = MEDIA[listName];
        if (!L.length) return;
        cur = Math.max(0, Math.min(L.length - 1, k));
        var x = L[cur];
        var r = x.r;
        var m = r.media[x.mi];
        clearStage();
        var node;
        if (m.type === 'video') {
          node = document.createElement('video');
          node.controls = true;
          node.playsInline = true;
          node.preload = 'metadata';
          if (m.full) node.poster = m.full;
          node.src = m.src;
        } else {
          node = document.createElement('img');
          node.src = m.full;
          node.alt = copy('photoAltTpl', "Photo from {name}'s review").split('{name}').join(r.name || '');
        }
        stage.insertBefore(node, stage.firstChild);
        pos.textContent = copy('lbPos', '{k} / {n}').split('{k}').join(fmtN(cur + 1)).split('{n}').join(fmtN(L.length));
        prev.hidden = cur === 0;
        next.hidden = cur === L.length - 1;
        hearts.innerHTML = heartsHtml(r.rating);
        strip.innerHTML = r.media.length > 1 ? r.media.map(function (mm, j) {
          var idx = mediaIndex(listName, r, j);
          return thumbHtml(r, mm, listName + ':' + idx, { cls: j === x.mi ? 'is-on' : '' });
        }).join('') : '';
        strip.hidden = r.media.length < 2;
        t.textContent = r.title || '';
        t.hidden = !r.title;
        b.innerHTML = r.body ? bodyHtml(r.body).replace(/^<div class="kkprv-rev__body">|<\/div>$/g, '') : '';
        b.hidden = !r.body;
        who.innerHTML = whoHtml(r).replace(/^<div class="kkprv-rev__who">|<\/div>$/g, '');
      }
      function focusables() {
        return Array.prototype.filter.call(lb.querySelectorAll('button, a[href], video[controls]'), function (n) { return !n.hidden && !n.closest('[hidden]'); });
      }
      function onKey(e) {
        if (e.key === 'Escape') { e.preventDefault(); close(); return; }
        if (e.key === 'ArrowRight' && !(e.target && e.target.tagName === 'VIDEO')) { show(cur + 1); return; }
        if (e.key === 'ArrowLeft' && !(e.target && e.target.tagName === 'VIDEO')) { show(cur - 1); return; }
        if (e.key !== 'Tab') return;
        var f = focusables();
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
      function open(list, k, el) {
        if (!MEDIA[list] || !MEDIA[list].length) return;
        listName = list;
        opener = el;
        show(k);
        lb.hidden = false;
        prevOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        document.addEventListener('keydown', onKey);
        closeBtn.focus();
      }
      function close() {
        if (lb.hidden) return;
        lb.hidden = true;
        clearStage(); // stops a playing video
        document.documentElement.style.overflow = prevOverflow;
        document.removeEventListener('keydown', onKey);
        if (opener && opener.isConnected) opener.focus({ preventScroll: true });
        opener = null;
      }
      lb.addEventListener('click', function (e) {
        if (e.target === lb) { close(); return; }
        var nav = e.target.closest('[data-kkprv-lb-nav]');
        if (nav) { show(cur + parseInt(nav.getAttribute('data-kkprv-lb-nav'), 10)); return; }
        var th = e.target.closest('[data-kkprv-media]');
        if (th) show(parseInt(th.getAttribute('data-kkprv-media').split(':')[1], 10) || 0);
      });
      closeBtn.addEventListener('click', close);
      return { open: open };
    })();

    function setWriteLabel(zero) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-kkprv-write]'), function (btn) {
        if (!btn.dataset.kkLabel) btn.dataset.kkLabel = btn.textContent;
        btn.textContent = zero ? copy('zeroCta', 'Be the first to review') : btn.dataset.kkLabel;
      });
    }
    // No reviews (or the load failed): one centred column — the zero card, the
    // CTA and the Club note. No gallery, toolbar or bars.
    function showZero(failed) {
      root.classList.add('kkprv--empty');
      var zero = root.querySelector('[data-kkprv-zero]');
      if (!zero) return;
      var h = zero.querySelector('[data-kkprv-zero-h]');
      var p = zero.querySelector('[data-kkprv-zero-p]');
      if (h) h.hidden = !!failed;
      if (p) {
        p.textContent = failed
          ? copy('errorText', 'Reviews could not be loaded just now. Please refresh the page to try again.')
          : copy('zeroBody', 'Tried the {product}? Tell other collectors how they fit, feel and look in your binder.').split('{product}').join(root.dataset.productName || '');
      }
      zero.hidden = false;
      setWriteLabel(!failed);
    }

    function mountList(reviews) {
      REVIEWS = reviews;
      if (!reviews.length) { showZero(false); return; }
      root.classList.remove('kkprv--empty');
      renderSummary();
      renderGallery();
      renderList();
      loadHelpful(reviews);
      dbg('rendered', { reviews: reviews.length, written: reviews.filter(isWritten).length, media: MEDIA.main.length });
    }

    /* In API mode the summary boots as skeletons (the Liquid deliberately
     * renders no numbers). If the fetch never resolves, those skeletons would
     * shimmer forever — so every terminal failure path collapses the section
     * to its zero state with an honest message instead. */
    function showLoadFailed(root) {
      if (root.dataset.mode !== 'api') return;
      showZero(true);
    }

    /* Club nudge: "[review]" / "[media]" filled from the live rewards program
     * (window.KKRewards, cached /apps/rewards/program). Hidden until then and
     * when the program can't be read, so it never quotes a stale value. */
    function initClubNote() {
      var note = root.querySelector('[data-kkprv-club]');
      if (!note || !window.KKRewards || !window.KKRewards.get) return;
      window.KKRewards.get('/program').then(function (p) {
        var pts = (p && p.points) || {};
        var review = Number(pts.review_bonus) || 0;
        var media = Number(pts.review_media_bonus) || 0;
        if (review <= 0) return;
        var fmt = function (n) { return Number(n).toLocaleString('en-AU'); };
        note.innerHTML = note.innerHTML.split('[review]').join(fmt(review)).split('[media]').join(fmt(media));
        note.hidden = false;
      }).catch(function (e) { dbg('club note — program unavailable', String(e)); });
    }

    function wireModal(root) {
      if (!window.KKPrvModal) { dbg('modal — script not loaded'); return; }
      window.KKPrvModal.wire(root, { dbg: dbg, copy: copy, withN: withN });
    }

    /* =========================================================
     * BUNDLES — reviews of the products INSIDE this bundle.
     *
     * A bundle PDP typically has no reviews of its own long before the
     * products it contains run out of them. Those component reviews are
     * useful context but they are NOT reviews of this bundle: nobody who
     * wrote one bought it. So they are fetched separately and rendered in
     * their own labelled block, and they never touch the summary, bars,
     * chips or list above — those stay strictly this product's own reviews.
     * ========================================================= */
    function fetchProductReviews(proxyUrl, fetchCount, handle, id) {
      var qs = 'per_page=' + fetchCount + '&product_handle=' + encodeURIComponent(handle);
      var url = proxyUrl + (proxyUrl.indexOf('?') >= 0 ? '&' : '?') + qs;
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var all = (data && Array.isArray(data.reviews)) ? data.reviews : [];
          return all.filter(function (rev) {
            return reviewMatchesProduct(rev, handle, id) && reviewIsVisible(rev);
          });
        })
        .catch(function (e) {
          // One component failing must not cost the others their reviews.
          dbg('bundle component fetch FAILED', { handle: handle, error: String(e) });
          return [];
        });
    }


    function initBundleReviews(root) {
      var wrap = root.querySelector('[data-kkprv-bundle]');
      if (!wrap) {
        // The block is only server-rendered when Liquid decided this product
        // IS a bundle. See `is_bundle` / `bundle_title_marker` / `product_title`
        // in the section-settings dump at the top of this log.
        dbg('bundle — block not rendered: this product did not match a bundle title marker (or the feature is off)');
        return;
      }
      var list = wrap.querySelector('[data-kkprv-bundle-list]');
      if (!list) return;

      var items = [];
      try { items = JSON.parse(root.dataset.bundleItems || '[]'); }
      catch (e) { dbg('bundle_items parse FAILED', { error: String(e) }); }
      if (!items.length) {
        dbg('bundle — matched a bundle title, but no component products resolved (no kkumi.bundle_items / custom.bundle_items metafield, and no option name handleized to a real product)');
        return;
      }

      var proxyUrl = root.dataset.proxyUrl;
      var fetchCount = parseInt(root.dataset.fetchCount, 10) || 100;
      var max = parseInt(root.dataset.bundleMax, 10) || 12;
      dbg('bundle — fetching component reviews', { components: items.length, max: max });

      Promise.all(items.map(function (it) {
        return fetchProductReviews(proxyUrl, fetchCount, it.handle, it.id)
          .then(function (reviews) { return { item: it, reviews: reviews }; });
      })).then(function (groups) {
        // De-dupe (a bundle can list the same product twice), newest-first
        // per component, then round-robin across components so one recently
        // reviewed product can't fill the whole block.
        var seen = Object.create(null);
        var lanes = groups.map(function (g) {
          var kept = [];
          g.reviews.forEach(function (r) {
            var key = String(r.id || (r.product_handle + '|' + r.created_at + '|' + (r.reviewer && r.reviewer.name)));
            if (seen[key]) return;
            seen[key] = true;
            kept.push({ review: r, item: g.item });
          });
          kept.sort(function (a, b) {
            return new Date(b.review.created_at || b.review.updated_at || 0) - new Date(a.review.created_at || a.review.updated_at || 0);
          });
          return kept;
        });
        var flat = [];
        for (var depth = 0, drained = false; !drained; depth++) {
          drained = true;
          for (var li = 0; li < lanes.length; li++) {
            if (depth < lanes[li].length) { flat.push(lanes[li][depth]); drained = false; }
          }
        }
        var pillTpl = copy('bundlePillTpl', 'Review of {product}');
        var ariaTpl = copy('bundleAriaSource', 'Review of the included product {product}');
        // Rating-only component reviews add nothing out of context; only
        // reviews with something to read are shown here.
        var rows = flat.map(function (entry, i) {
          var title = entry.item.title || '';
          var r = fromApi(entry.review, i, {}, title);
          r.pill = pillTpl.split('{product}').join(title);
          r.aria = ariaTpl.split('{product}').join(title);
          return r;
        }).filter(isWritten).slice(0, max);
        dbg('bundle — component reviews found', {
          per_component: groups.map(function (g) { return g.item.handle + ':' + g.reviews.length; }),
          total: flat.length,
          rendering: rows.length,
        });
        if (!rows.length) return; // nothing to say — the block stays hidden

        MEDIA.bundle = [];
        rows.forEach(function (r) { r.media.forEach(function (m, mi) { MEDIA.bundle.push({ r: r, mi: mi }); }); });
        var shown = perPage;
        var moreWrap = wrap.querySelector('[data-kkprv-bundle-more-wrap]');
        var moreBtn = wrap.querySelector('[data-kkprv-bundle-more]');
        function draw() {
          var limit = loadMoreOn ? shown : rows.length;
          list.innerHTML = rows.slice(0, limit).map(function (r) {
            return reviewRowHtml(r, { component: true, ariaLabel: r.aria });
          }).join('');
          if (moreWrap) moreWrap.hidden = rows.length <= limit;
          if (moreBtn) moreBtn.textContent = moreLabel(Math.min(perPage, rows.length - limit));
        }
        if (moreBtn) moreBtn.addEventListener('click', function () { shown += perPage; draw(); });
        draw();
        wrap.hidden = false;
      });
    }

    /* =========================================================
     * API MODE — fetch reviews from the Cloudflare Worker proxy,
     * filter to the current product, then render.
     * ========================================================= */
    function initApiMode(root) {
      var proxyUrl = root.dataset.proxyUrl;
      var productHandle = root.dataset.productHandle;
      var productId = String(root.dataset.productId || '');
      var fetchCount = parseInt(root.dataset.fetchCount, 10) || 100;
      var variantMap = {};
      try { variantMap = JSON.parse(root.dataset.variantMap || '{}'); }
      catch (e) { dbg('variant_map parse FAILED', { error: String(e) }); }

      dbg('api init', {
        proxy_url: proxyUrl,
        product_handle: productHandle,
        product_id: productId,
        fetch_count: fetchCount,
        variant_map_keys: Object.keys(variantMap),
      });

      if (!proxyUrl) {
        dbg('ABORT: proxy_url is empty — set it in the section settings');
        showLoadFailed(root);
        wireModal(root);
        return;
      }
      if (!productHandle) {
        dbg('ABORT: product_handle is empty — section may not be on a PDP');
        showLoadFailed(root);
        wireModal(root);
        return;
      }

      var qs = 'per_page=' + fetchCount + '&product_handle=' + encodeURIComponent(productHandle);
      var url = proxyUrl + (proxyUrl.indexOf('?') >= 0 ? '&' : '?') + qs;
      dbg('fetch start', { url: url });

      var t0 = Date.now();
      // Stash so we can do a diagnostic fallback fetch
      var lastFetchCacheHit = null;

      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) {
          var cacheHdr = r.headers.get('x-cache');
          lastFetchCacheHit = cacheHdr === 'HIT';
          dbg('fetch response', {
            status: r.status,
            ok: r.ok,
            x_cache: cacheHdr,
            content_type: r.headers.get('content-type'),
            duration_ms: Date.now() - t0,
          });
          if (cacheHdr === 'HIT') {
            dbg('⚠️ x-cache=HIT — the worker is serving a previously-cached response. If you just added/published a review, that response is up to 10 minutes stale. Purge it via Cloudflare → your worker → Caches, or redeploy the worker.');
          }
          if (!r.ok) {
            return r.text().then(function (body) {
              dbg('non-OK response body', body.slice(0, 800));
              throw new Error('Proxy returned ' + r.status);
            });
          }
          return r.json();
        })
        .then(function (data) {
          dbg('raw response — top-level keys', Object.keys(data || {}));
          dbg('worker version stamp', {
            worker: data._kkumi_worker || '(missing — cache is serving an older blob, or worker is running an older build)',
          });
          var all = Array.isArray(data.reviews) ? data.reviews : [];
          dbg('reviews array length', all.length);
          if (all.length === 0) {
            dbg('full payload (no reviews returned)', data);
            // Diagnostic: hit the worker WITHOUT product_handle so we can
            // tell apart "shop genuinely has no reviews" vs "shop has
            // reviews but product filter / handle mismatch is dropping
            // them". Fire and forget — purely a console hint.
            var diagUrl = proxyUrl + (proxyUrl.indexOf('?') >= 0 ? '&' : '?') + 'per_page=' + fetchCount;
            dbg('🔎 zero-result diagnostic — refetching without product_handle', { url: diagUrl });
            fetch(diagUrl, { headers: { Accept: 'application/json' } })
              .then(function (r2) {
                dbg('diagnostic fetch response', { status: r2.status, x_cache: r2.headers.get('x-cache') });
                return r2.ok ? r2.json() : null;
              })
              .then(function (d2) {
                if (!d2) { dbg('diagnostic — unparseable response'); return; }
                var all2 = Array.isArray(d2.reviews) ? d2.reviews : [];
                dbg('diagnostic — shop-wide reviews returned', all2.length);
                if (all2.length > 0) {
                  dbg('  → reviews exist in this shop. The product filter is dropping them.');
                  dbg('  → most likely: the handle Judge.me has for this product != the Shopify handle, OR the worker isn\'t forwarding product_handle yet (redeploy from apps/workers/kkumi-reviews-proxy.js).');
                  dbg('  shop-wide review[0] identifiers', {
                    product_handle: all2[0].product_handle,
                    product_external_id: all2[0].product_external_id,
                    product_id: all2[0].product_id,
                    product_title: all2[0].product_title,
                  });
                  dbg('  PDP identifiers to compare', { handle: productHandle, id: productId });
                } else {
                  dbg('  → shop-wide returned 0 reviews too. Possible causes:');
                  dbg('     (a) Worker SHOP_DOMAIN / JUDGEME_PRIVATE_TOKEN env vars wrong / missing');
                  dbg('     (b) The published reviews are still in moderation (Judge.me admin → Manage Reviews)');
                  dbg('     (c) Cache HIT serving stale empty — purge or redeploy worker');
                  dbg('     (d) Open the worker URL directly in your browser to see what Judge.me is actually returning');
                }
              })
              .catch(function (e2) { dbg('diagnostic fetch FAILED', String(e2)); });
          } else {
            var sample = all[0];
            dbg('first review keys', Object.keys(sample));
            dbg('first review identifiers', {
              id: sample.id,
              product_id: sample.product_id,
              product_external_id: sample.product_external_id,
              product_handle: sample.product_handle,
              product_title: sample.product_title,
              rating: sample.rating,
              published: sample.published,
              hidden: sample.hidden,
              created_at: sample.created_at,
            });
            dbg('PDP identifiers to match against', { handle: productHandle, id: productId });
          }

          var matches = 0, droppedHandle = 0, droppedId = 0, droppedVis = 0;
          var filtered = all.filter(function (r, i) {
            var handleMatch = productHandle && r.product_handle && String(r.product_handle).toLowerCase() === productHandle.toLowerCase();
            var idMatch     = productId && (String(r.product_external_id) === productId || String(r.product_id) === productId);
            var matchesProduct = reviewMatchesProduct(r, productHandle, productId);
            var isVisible = reviewIsVisible(r);
            if (!matchesProduct) {
              if (i < 5) dbg('drop review #' + i + ' — product mismatch', {
                review_handle: r.product_handle, review_external_id: r.product_external_id, review_product_id: r.product_id,
                handle_match: !!handleMatch, id_match: !!idMatch,
              });
              if (handleMatch === false) droppedHandle++; else droppedId++;
            } else if (!isVisible) {
              dbg('drop review #' + i + ' — not visible', { published: r.published, hidden: r.hidden });
              droppedVis++;
            } else {
              matches++;
            }
            return matchesProduct && isVisible;
          });
          dbg('filter summary', {
            total_returned: all.length,
            matched: matches,
            dropped_product_mismatch: droppedHandle + droppedId,
            dropped_not_visible: droppedVis,
          });

          root.classList.toggle('kkprv--empty', filtered.length === 0);
          dbg('rendering', { count: filtered.length, empty: filtered.length === 0 });
          var productTitle = root.dataset.productTitle || '';
          mountList(filtered.map(function (r, i) { return fromApi(r, i, variantMap, productTitle); }));
          wireModal(root);
          // Independent of the summary above, and deliberately after it: the
          // bundle's own numbers must never wait on (or be changed by) the
          // component fetches.
          initBundleReviews(root);
          dbg('render complete');
        })
        .catch(function (err) {
          dbg('FETCH FAILED', { error: String(err), stack: err && err.stack });
          dbg('hint', 'Check: (1) worker URL correct, (2) worker deployed with the latest source, (3) CORS allow-list includes this origin (' + window.location.origin + '), (4) network tab for the actual request/response.');
          showLoadFailed(root);
          wireModal(root);
          initBundleReviews(root);
        });
    }

    function initDemoMode(root) {
      var node = root.querySelector('[data-kkprv-demo]');
      var data = [];
      try { data = JSON.parse((node && node.textContent) || '[]'); }
      catch (e) { dbg('demo blocks parse FAILED', String(e)); }
      mountList((Array.isArray(data) ? data : []).map(fromDemo));
    }

    wireList();
    initClubNote();
    if (root.dataset.mode === 'api') {
      initApiMode(root);
    } else {
      initDemoMode(root);
    }
  })();
